import { render, staticRenderFns } from "./newOrganizations.vue?vue&type=template&id=07e6defa&scoped=true&"
import script from "./newOrganizations.vue?vue&type=script&lang=js&"
export * from "./newOrganizations.vue?vue&type=script&lang=js&"
import style0 from "./newOrganizations.vue?vue&type=style&index=0&id=07e6defa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e6defa",
  null
  
)

export default component.exports